import api from './api'
import {
  UsuarioAdmin,
  UsuarioCreateRequest,
  UsuarioUpdateRequest,
} from '@/types/usuario'

const BASE_URL = '/api/v1/usuarios'

export const usuarioService = {
  listar: async (params: { search?: string; first?: number; max?: number } = {}): Promise<UsuarioAdmin[]> => {
    const sp = new URLSearchParams()
    sp.append('first', String(params.first ?? 0))
    sp.append('max', String(params.max ?? 100))
    if (params.search) sp.append('search', params.search)
    return api.get<UsuarioAdmin[]>(`${BASE_URL}?${sp.toString()}`)
  },

  obter: async (id: string): Promise<UsuarioAdmin> => {
    return api.get<UsuarioAdmin>(`${BASE_URL}/${id}`)
  },

  criar: async (request: UsuarioCreateRequest): Promise<UsuarioAdmin> => {
    return api.post<UsuarioAdmin>(BASE_URL, request)
  },

  atualizar: async (id: string, request: UsuarioUpdateRequest): Promise<UsuarioAdmin> => {
    return api.put<UsuarioAdmin>(`${BASE_URL}/${id}`, request)
  },

  deletar: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`)
  },

  /** Reseta o 2FA do usuário — ele reconfigura o autenticador no próximo login. */
  resetarTwoFactor: async (id: string): Promise<void> => {
    await api.post(`${BASE_URL}/${id}/reset-2fa`)
  },

  // ─── Saneamento do OPERADOR indevido (defeito de defaultRoles do realm) ───

  saneamentoOperador: async (): Promise<DiagnosticoOperador> => {
    return await api.get<DiagnosticoOperador>(`${BASE_URL}/saneamento-operador`)
  },

  /** Revoga em lote SÓ de quem veio do funil de consultor — o grupo com evidência. */
  revogarOperadorDoFunil: async (): Promise<PortadorOperador[]> => {
    return await api.post<PortadorOperador[]>(`${BASE_URL}/saneamento-operador/revogar-funil`)
  },

  /** Contas sem origem no funil: decisão humana, uma a uma. */
  revogarOperadorIndividual: async (usuarioId: string): Promise<void> => {
    await api.post(`${BASE_URL}/saneamento-operador/revogar/${usuarioId}`)
  },
}

// Espelham os records de SaneamentoOperadorService.
export interface PortadorOperador {
  usuarioId: string
  email?: string
  nome?: string
  habilitado: boolean
  veioDoFunil: boolean
  outrosPapeis: string[]
}

export interface DiagnosticoOperador {
  /** Revogáveis por evidência: têm candidatura do funil vinculada à conta. */
  consultoresDoFunil: PortadorOperador[]
  /** Nunca revogados automaticamente — decisão humana. */
  semOrigemNoFunil: PortadorOperador[]
}
